export default "__VITE_ASSET__a6e5fd1b__"